export function namespacedService(key: string) {
  return `@3nickels/web/${key}`;
}
